module.exports = __webpack_public_path__ + "static/media/icon_benefit_apple.9f1a2f8d.svg";